import { Injectable } from '@angular/core';
import gql from 'graphql-tag';

import { GetAdvanceEventOutcomesHistoryQuery, GetAdvanceEventOutcomesOpenedQuery } from '../telemetry/index.graph-ql';
import { AdvanceEventOutcomes, AdvanceEventOutcomesHistory } from '../telemetry';
import { getTelemetryRangeWithTzOnHour } from '../utils';

const currentEventsQueryFragment = `
  fragment advanceeventoutcomes on AdvanceEventOutcomes {
    deviceId,
    eventModelName,
    open_ts,
  }
`
const historicalEventsQueryFragment = `
  fragment advanceeventoutcomeshistory on AdvanceEventOutcomesHistory {
    deviceId,
    eventModelName,
    open_ts,
    close_ts,
  }
`
@Injectable({
  providedIn: 'root'
})
export class EventsService {
  constructor(
    private readonly getAdvanceEventOutcomesOpenedQuery: GetAdvanceEventOutcomesOpenedQuery,
    private readonly getAdvanceEventOutcomesHistoryQuery: GetAdvanceEventOutcomesHistoryQuery,
  ) {}

  async fetchCurrentSystemEvent(plantId:string , refresh: boolean = false): Promise<Partial<AdvanceEventOutcomes>[]>
  {
    const currentEvents = await this.getAdvanceEventOutcomesOpenedQuery.execute(gql`${currentEventsQueryFragment}`, { plantId }, refresh);
    return currentEvents.data.getAdvanceEventOutcomesOpened;
  }

  async fetchDailyHistoricalSystemEvent(
    plantId: string,
    date: string,
    refresh: boolean = false,
    tz: string,
  ): Promise<Partial<AdvanceEventOutcomesHistory>[]>  {
    const range = getTelemetryRangeWithTzOnHour(date, tz);
    const historicalEvents = await this.getAdvanceEventOutcomesHistoryQuery.execute(gql`${historicalEventsQueryFragment}`, { plantId, range }, refresh);
    return historicalEvents.data.getAdvanceEventOutcomesHistory;
  }

}